<template>
  <div class="" :id="this.$route.name">
    <div class="container">
      <div class="row">
        <div class="mb-3">
          <a v-if="AddPresence == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddPresence = 1" title="افزودن دمو | حضور جدید">
            <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
          </a>
          <a
            v-if="AddPresence != 0"
            class="d-inline float-right mx-2 mt-1"
            href="javascript:;"
            @click="
              AddPresence = 0
              Reload()
            "
            title="لغو افزودن"
          >
            <h4><i class="fas fa-times text-danger"></i></h4>
          </a>
        </div>
        <div class="col-12" v-if="AddPresence != 0">
          <div class="row" id="Presence">
            <div class="col-md-3 col-12">
              <div class="mt-2">
                <small id="LbltblUserId">انتخاب کاربر</small>
                <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3" :defaultvalue="DataAxios.tblUserId" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserId'" :keyItem="'UserId'" :disabled="false" :ClassProps="'required'">
                </SearchableCombo>
              </div>
            </div>
            <div class="col-md-3 col-12">
              <div class="mt-2">
                <small id="LbltblCombogrp30NoeHozor">نوع حضور</small>
                <SearchableCombo
                  :edit="false"
                  :grp="30"
                  :code="null"
                  @ResultCombo="GetResulNoeHozor"
                  :rownumintable="3"
                  :defaultvalue="DataAxios.tblCombogrp30NoeHozor"
                  :action="'TblCrmCombo/GetComboById'"
                  :method="'POST'"
                  :idinput="'tblCombogrp30NoeHozor'"
                  :keyItem="'tblCombogrp30NoeHozor'"
                  :disabled="false"
                  :ClassProps="'required'"
                >
                </SearchableCombo>
              </div>
            </div>
            <div class="col-md-3 col-12">
              <div class="mt-2">
                <small id="LblDate"> تاریخ دمو | حضور</small>
                <date-picker color="dimgray" v-model="DataAxios.Date" :editable="true"></date-picker>
              </div>
            </div>
            <div class="col-md-3 col-12">
              <div class="mt-2">
                <small id="LblTime">مدت حضور (ساعت)</small>
                <input type="text" class="form-control InputText required" v-model="DataAxios.Time" />
              </div>
            </div>
            <div class="col-md-12 col-12">
              <div class="">
                <small id="LblDescription">توضیحات</small>
                <textarea class="form-control InputText required" v-model="DataAxios.Description"></textarea>
              </div>
            </div>
            <div class="col-md-5 col-12">
              <div class="mt-2">
                <small id="LblExpense">مبلغ هزینه</small>
                <input type="text" class="form-control InputText required 3ragham" v-model="DataAxios.Expense" @keyup="DataAxios.Expense = $PutCommatoInput_New($event)" />
              </div>
            </div>
            <div class="col-md-4 col-12 mt-2"></div>
            <div class="col-md-3 col-12 mt-2">
              <button v-if="AddPresence == 1" class="btn btn-success mt-4 text-center w-100" @click="SetPresence">ثبت حضور</button>
              <button v-if="AddPresence == -1" class="btn btn-warning mt-4 text-center w-100" @click="EditPresence">ویرایش حضور</button>
            </div>
          </div>
        </div>
        <div class="col-12" v-else>
          <div class="" v-if="PresenceList.length > 0">
            <BnpGrid v-if="$store.state.renderComponentTicket" :sortable="true" :hasRowNum="true" :propsColumn="Column" :propsRows="PresenceList" :Selectable="false" :action="true">
              <template slot="Expense" slot-scope="props">
                <span>
                  {{ props.props.Expense == null ? '-' : $Comma3ragham(Math.floor(props.props.Expense)) }}
                </span>
              </template>
              <template slot="action-slot" slot-scope="props">
                <a href="javascript:;" v-if="IsAccess('btnEditPresence')" class="mr-2 badge" @click="OnEdit(props.props)"
                  ><h6><span class="fas fa-marker text-secondary hover-warning"></span></h6
                ></a>
                <a href="javascript:;" v-if="IsAccess('btnDeletePresence')" class="mr-2 badge" @click="OnDelete(props.props)"
                  ><h6><span class="fas fa-trash-alt text-secondary hover-danger"></span></h6
                ></a>
              </template>
            </BnpGrid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      AddPresence: 0,
      DataAxios: {
        tblUserId: this.$session.get('UserInfo').tblUserId,
      },
      DataAxoisCol: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmPresence',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      Column: [],
      elmAccess: [],
      Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
    }
  },
  components: {
    Card,
    datePicker: VuePersianDatetimePicker,
    SearchableCombo,
    BnpGrid,
  },
  methods: {
    GetResulUserId(value) {
      this.DataAxios.tblUserId = value.id
    },
    GetResulNoeHozor(value) {
      this.DataAxios.tblCombogrp30NoeHozor = value.id
    },
    Reload() {
      this.DataAxios = {}
      this.AddPresence = 0
    },
    SetPresence() {
      if (this.$ValidForm('Presence')) {
        this.DataAxios.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
        this.DataAxios.tblCustomerId = this.CustomerId
        var DataAxios_SetPresence = { Action: 'Presence', Method: 'post', ArryfildValue: this.DataAxios }
        this.$PostData(DataAxios_SetPresence).then((result) => {
          if ((result.status = 'success')) {
            this.Reload()
            this.$store.state.renderComponentTicket = false
            this.$nextTick(() => {
              this.$store.state.renderComponentTicket = true
            })
            this.$emit('Inserted', { done: 'OK', activeTab: 7 })
          }
        })
      }
    },
    GetAccessUser() {
      var menu = this.$session.get('Menu')
      var IdMenu = menu.find((x) => x.RouteName == this.$route.name).id
      this.elmAccess = menu.filter((x) => x.ParentId == IdMenu)
    },
    IsAccess(elmId) {
      let IsExist = false
      this.elmAccess.forEach((element) => {
        if (element.ControlName == elmId) {
          if (element.isMojaz == 1) {
            IsExist = true
          }
        }
      })
      return IsExist
    },
    OnDelete(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row)
      var DataAxiosDelete = {
        ArryfildValue: '',
        Method: 'Delete',
        Action: 'Presence',
        Token: this.$session.get('Token'),
      }
      DataAxiosDelete.ArryfildValue = { id: row.Id }
      this.$DeleteDatapropmise(DataAxiosDelete, this.Sweet).then((result) => {
        // console.log(result)
        if (result == true) {
          this.$SetLog(row, 1, 0, 'Presence', 'دمو | حضور')
          this.$emit('Inserted', { done: 'OK', activeTab: 7 })
        }
      })
    },
    OnEdit(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row)
      this.DataAxios = row
      this.DataAxios.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      this.AddPresence = -1
    },
    EditPresence() {
      if (this.$ValidForm('Presence')) {
        delete this.DataAxios['id']

        this.DataAxios.Expense = Number((this.DataAxios.Expense + '').replace(/,/g, ''))
        // this.Personel.tblCustomerId=this.Customer.Customer.Id
        var DataAxiosEditDataAxios = { Action: 'Presence/Edit_Presence', Method: 'post', ArryfildValue: this.DataAxios }
        this.$PostData(DataAxiosEditDataAxios).then((result) => {
          if ((result.status = 'Success')) {
            this.$SetLog(this.DataAxios, 0, 0, 'Presence', 'دمو | حضور')
            this.Reload()
            this.$emit('Inserted', { done: 'OK', activeTab: 7 })
          }
        })
      }
    },
  },
  props: ['CustomerId', 'PresenceList'],
  beforeMount() {
    this.$GetColumns(this.DataAxoisCol, true)
      .then((data) => {
        this.Column = data
      })
      .finally(() => {
        // console.log(this.Column)
        this.$store.state.renderComponentTicket = false
        this.$nextTick(() => {
          this.$store.state.renderComponentTicket = true
        })
      })
  },
  mounted() {
    this.GetAccessUser()
  },
}
</script>
<style scoped></style>
